import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SendingService } from 'app/modules/fuse/services/sending.service';

@Component({
    selector: 'app-open-discharge-request-popup',
    templateUrl: './open-discharge-request-popup.component.html',
    styleUrls: ['./open-discharge-request-popup.component.scss'],
    standalone: false
})
export class OpenDischargeRequestPopupComponent implements OnInit {

  public requestForm: UntypedFormGroup;
  public admintrativeUsers = [];  
  public SelectedAdministrativeUser: any;
  public IsCancelDissabled:boolean=false;
  constructor(
    private dialogRef: MatDialogRef<OpenDischargeRequestPopupComponent>,
    private _sharedService: SharedService,
    private _sendingService: SendingService,
    private _fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) private users
  ) {
    this.admintrativeUsers = users.admintrativeUsers
  }

  ngOnInit(): void {
    this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');
    this.createReportsForm();
  }

  createReportsForm() {
    this.requestForm = this._fb.group({
      SelectedAdministrativeUser: [''],
      SelectedCompanyId: [this._sendingService.selectedCompanyId]
    });
  }

  public onAdminUserChange(event: any) {
    this.SelectedAdministrativeUser = event.value;
}

  onSubmit(): void {
    this.requestForm.markAllAsTouched();
    if (this.requestForm.valid) {
      this.IsCancelDissabled=true;
      this._sendingService.SolicitudesDeAltas(this.requestForm.value).subscribe(res => {
        if (res.result != null && res.code === 0) {
          this.close();
          this.IsCancelDissabled=false;
          this._sharedService.ShowSnackBar(res.result);
        } else {
          this.close();
          this.IsCancelDissabled=false;
          this._sharedService.ShowSnackBar('lo siento, el proceso falló');
        }
      }, error => {
        this.close();
        this.IsCancelDissabled=false;
        this._sharedService.ShowSnackBar('API Se produjo un error');
        console.error(error);
      });
    
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
